import { convertFileToBase64 } from "../utils/convertToBase64";

export const generateStudentFormData = async (formData, isSubmitted) => {
  const passportfilebase64 = formData?.passportPhoto
    ? await convertFileToBase64(formData.passportPhoto)
    : null;
  const passportfileExtension = formData?.passportPhoto?.name?.split(".").pop();

  const marriageCertfilebase64 = formData?.marriageCertfile
    ? await convertFileToBase64(formData.marriageCertfile)
    : null;
  const marriageCertfileExtension = formData?.marriageCertfile?.name
    ?.split(".")
    .pop();

  return {
    personalInfo: {
      title: formData?.title || "",
      firstName: formData?.firstname || "",
      lastName: formData?.surname || "",
      otherName: formData?.otherName || "",
      phoneNumber: formData?.telephone || "",
      dateOfBirth: formData?.DOB || "",
      gender: formData?.gender || "",
      postCode: formData?.postCode || "",
      country: formData?.country || "",
      stateOfOrigin: formData?.stateOfOrigin || "",
      homeAddress: formData?.address || "",
      passport: passportfilebase64
        ? {
            extension: `.${passportfileExtension}`,
            data: passportfilebase64,
          }
        : null,
    },
    marriageInfo: {
      maritalStatus: formData?.maritalStatus || "",
      marriageCertificate: marriageCertfilebase64
        ? {
            extension: `.${marriageCertfileExtension}`,
            data: marriageCertfilebase64,
          }
        : null,
    },
    refereeInfo: {
      membershipId: formData?.RefMembershipNumber || "",
      fullName: formData?.RefFullName || "",
      email: formData?.RefEmailAddress || "",
      phoneNumber: formData?.RefPhoneNumber || "",
      qualification: formData?.refereeQualifications || "",
      jobTitle: formData?.occupation || "",
    },
    isSubmitted: isSubmitted,
  };
};
